import { useState } from 'react';

import { useUpdateWorkspace } from '../../api/queries.js';
import { useAuthStore } from '../../auth/auth-store.js';
import { Button, Field, Input, PageHeader, Select } from '../../components/ui/index.js';

export function SettingsGeneral(): JSX.Element {
  const user = useAuthStore((s) => s.user);
  const slug = user?.workspaceSlug;
  const update = useUpdateWorkspace(slug);

  const [name, setName] = useState(user?.workspaceName ?? '');
  const [workspaceSlug, setWorkspaceSlug] = useState(slug ?? '');
  const [timezone, setTimezone] = useState('Europe/Moscow');
  const [lang, setLang] = useState('ru');
  const [notifEmail, setNotifEmail] = useState('');
  const [saved, setSaved] = useState(false);

  async function handleSave(): Promise<void> {
    await update.mutateAsync({ name, slug: workspaceSlug, timezone, language: lang });
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  }

  return (
    <div className="inbx-page">
      <PageHeader title="Общие настройки" />
      <div className="inbx-page__body" style={{ maxWidth: 640 }}>
        <div className="inbx-card">
          <h4 className="inbx-card__title">Workspace</h4>
          <Field label="Название" required>
            <Input value={name} onChange={(e) => setName(e.target.value)} />
          </Field>
          <Field label="Slug (URL)" required hint="используется в URL и API">
            <Input value={workspaceSlug} onChange={(e) => setWorkspaceSlug(e.target.value)} />
          </Field>
          <Field label="Часовой пояс">
            <Select value={timezone} onChange={(e) => setTimezone(e.target.value)}>
              <option>Europe/Moscow</option>
              <option>Europe/Kaliningrad</option>
              <option>Asia/Yekaterinburg</option>
              <option>Asia/Novosibirsk</option>
              <option>Asia/Vladivostok</option>
              <option>Europe/London</option>
              <option>America/New_York</option>
            </Select>
          </Field>
          <Field label="Язык интерфейса">
            <Select value={lang} onChange={(e) => setLang(e.target.value)}>
              <option value="ru">Русский</option>
              <option value="en">English</option>
            </Select>
          </Field>
          <Button variant="primary" onClick={handleSave} disabled={update.isPending}>
            {saved ? '✓ Сохранено' : update.isPending ? 'Сохранение…' : 'Сохранить'}
          </Button>
        </div>
        <div className="inbx-card">
          <h4 className="inbx-card__title">Уведомления workspace</h4>
          <Field label="Email для системных уведомлений">
            <Input
              type="email"
              placeholder="admin@demo.local"
              value={notifEmail}
              onChange={(e) => setNotifEmail(e.target.value)}
            />
          </Field>
          <Button
            variant="secondary"
            onClick={() => void update.mutateAsync({ notification_email: notifEmail })}
            disabled={update.isPending || !notifEmail}
          >
            Сохранить email
          </Button>
        </div>
      </div>
    </div>
  );
}
